/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\OPEL.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:18:34 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function OPEL(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M245.85,515.89c-6.32-.47-12.55-1-18.79-1.38-19.65-1.2-39.32-2.25-58.95-3.65-2.39-.17-5.3-1.59-6.81-3.39-2.02-2.4-.14-5.08,1.54-7.37,4.85-6.61,9.7-13.23,14.4-19.95,2.91-4.17,6.68-6.08,11.8-6.05,19.56,.11,39.12,.04,58.68,.04h4.54c21.98-86.1,70.92-151.6,148.99-194.14,57.97-31.59,120.3-41.72,185.37-31.18,75.69,12.26,137.75,48.98,185.2,109.15,47.48,60.21,67.45,129.27,62.39,206.02,6.32,.42,12.42,.83,18.53,1.23,20.06,1.3,40.12,2.53,60.17,3.91,6.73,.46,8.6,4.82,4.62,10.4-4.68,6.57-9.57,12.99-14.11,19.65-3.14,4.61-7.13,6.65-12.75,6.6-19.42-.17-38.84,.04-58.26-.16-3.66-.04-5.1,.97-6.07,4.57-28.37,104.53-93.39,176.06-196.05,210.25-162.02,53.96-337.37-45.29-376.93-211.43-6.79-28.51-9.61-57.37-7.51-86.66,.14-2.02,.02-4.05,.02-6.45Zm34.25,2.05c-5.04,77.97,18.21,145.64,71.84,202.27,70.35,74.29,177.59,100.48,274.79,65.44,85.64-30.87,139.73-92.31,166.23-179.95-2.83,0-4.56,0-6.29,0-125.14,0-250.28,0-375.42,0-1.64,0-3.45,.37-4.88-.19-1.61-.63-3.64-1.89-4.07-3.32-.44-1.43,.66-3.49,1.47-5.08,.44-.87,1.68-1.33,2.58-1.95,21.59-14.92,43.18-29.84,64.76-44.76,8.72-6.03,17.43-12.08,27.2-18.85-73.25-4.57-145.23-9.06-218.2-13.62Zm7.87-43.8h5.63c125.29,0,250.57,0,375.86,0,1.5,0,3.19-.38,4.47,.17,1.6,.69,3.6,1.93,4.07,3.37,.46,1.43-.49,3.56-1.36,5.08-.62,1.08-2.11,1.67-3.24,2.44-26.49,18.16-52.99,36.31-79.49,54.47-3.67,2.51-7.33,5.04-12.08,8.29,73.46,4.68,145.63,9.27,217.79,13.86,12.38-128.41-77.66-256.88-218.49-279.32-139.39-22.21-261.87,68.98-293.15,191.64Z"/>
        </svg>
    );
}

export default OPEL;
